import { apiClient } from "../utils/apiClient";
import {CREATE_EVENT_URL, ORGANIZER_EVENTS_URL} from "../config/api";

export const organizerEventsService = {

    async createEvent(eventData: any, flyerFile: File) {
        const formData = new FormData();
        const jsonBlob = new Blob([JSON.stringify(eventData)], {
            type: 'application/json'
        });
        formData.append('event', jsonBlob);
        formData.append('flyer', flyerFile);

        const response = await apiClient(CREATE_EVENT_URL, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || 'Error creating event');
        }
        return await response.json();
    },

    async getMyEvents() {
        const response = await apiClient(`${ORGANIZER_EVENTS_URL}?page=0&size=50&sort=startDate,desc`);

        if (!response.ok) {
            throw new Error('Error fetching organizer events');
        }
        return await response.json();
    },

    async getEventById(id: string) {
        const response = await apiClient(`${ORGANIZER_EVENTS_URL}/${id}`);
        if (!response.ok) throw new Error('No se pudo cargar el evento');
        return await response.json();
    },

    async updateEvent(id: string, eventData: any, flyerFile: File | null) {
        const formData = new FormData();

        const eventPayload = { ...eventData, id: id };
        const jsonBlob = new Blob([JSON.stringify(eventPayload)], { type: 'application/json' });
        formData.append('event', jsonBlob);

        if (flyerFile) {
            formData.append('flyer', flyerFile);
        }

        const response = await apiClient(`${ORGANIZER_EVENTS_URL}/${id}`, {
            method: 'PUT',
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || 'Error al actualizar el evento');
        }
        return await response.json();
    }
};